module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "ui-btn",
    on: {
      "click": _vm.onCodeClick
    }
  }, [_vm._v("获取验证码")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show),
      expression: "!show"
    }],
    staticClass: "ui-btn ui-btn-disable"
  }, [_vm._v(_vm._s(_vm.codeNum + '秒后重试'))]), _vm._v(" "), _c('tips', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tips),
      expression: "tips"
    }],
    attrs: {
      "btnNum": _vm.btnNum,
      "tipsFont": _vm.tipsFont
    },
    on: {
      "tipStatus": _vm.tipStatus
    }
  }), _vm._v(" "), _c('tips-auto', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsauto),
      expression: "tipsauto"
    }],
    attrs: {
      "tipsFont": _vm.tipsFont
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d2e720f0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileCode.vue
// module id = 622
// module chunks = 1